import * as React from "react";
const MObileBurgerSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#EE4137"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 5h-8m8 7H8m13 7H3"
    />
  </svg>
);
export default MObileBurgerSVG;
